// extracted by mini-css-extract-plugin
export default {"carsPlaceholder":"_23brR","autosBannerImage":"_1Arr1","autosBannerImageMobile":"_3BuYi"};